import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore } from '@mcn-platform/models';
import MembershipPrice from './MembershipPrice';
import PlaceHolder from '../common/PlaceHolder';
const PurchaseMembership = ({ membershipId, editData, }) => {
    const store = useStore();
    const [membership, setMembership] = useState();
    useEffect(() => {
        if (membershipId) {
            const stub = store.getOrLoad('membership', membershipId);
            setMembership(stub);
        }
        else {
            setMembership(undefined);
        }
    }, [membershipId, membership?.syncState, store]);
    // console.log('membership : ', membershipId, membership);
    const isEmpty = () => (!membership && editData);
    if (isEmpty()) {
        return (_jsx(PlaceHolder, { placeHolderName: "Configure Purchase Membership" }));
    }
    return (_jsx(Box, { sx: {
            width: '100%',
            boxShadow: '0 0 18px 0 rgba(9, 32, 46, 0.2)',
        }, children: membership && (_jsxs(Box, { children: [_jsx(Typography, { variant: "h4", sx: {
                        m: '1em',
                    }, children: membership.name }), _jsx(Typography, { variant: "h6", sx: {
                        m: '1em',
                    }, children: membership.description }), _jsx(MembershipPrice, { membership: membership, currency: "USD" })] })) }));
};
PurchaseMembership.meta = {
    group: 'hidden',
    name: 'Purchase Membership',
    description: 'Component adds purchase CTA for a membership',
    props: [
        {
            key: 'membershipId',
            name: 'Select membership to purchase',
            type: 'membership',
            description: 'Select membership to purchase',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'PurchaseMembership',
        props: {
            membershipId: undefined,
        },
    },
};
export default observer(PurchaseMembership);
//# sourceMappingURL=PurchaseMembership.js.map